<!--
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月23日 11:40:35
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
    <div :class="['tabs-dialog',isApp?'no-header':'']" >
        <div class="tabs-container">
            <div class="tabs">
                <div @click="goTab(tab,index)" class="tab" v-for="(tab,index) in tabs" :key="tab.path">
                    <div v-if="tab.show" :class="activeIndex==index?'active':''" style="margin-right: 0.5rem">
                        {{tab.name}}
                    </div>
                </div>
            </div>
            <div v-if="$route.name!='nursingOne'&&$route.name!='nursingHistory' && !$store.state.isScanCode || $store.state.scanCode === $route.query.Id" @click="dialogVisible=true" class="save" type="primary">提交</div>
        </div>
        <myDialog :dialogVisible="dialogVisible" question="是否确认提交(不包含未来时间点记录)" @close="close"  @setup="updateSave" dialogWidth="66%"></myDialog>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import myDialog from '@/common/dialog.vue'
export default {
  // 组件参数 接收来自父组件的数据
  props: {
    tabs:Array
  },
  // 局部注册的组件
  components: {
      myDialog
  },
  // 组件状态值
  data () {
    return {
      isApp:true,
        activeIndex:0,
        dialogVisible:false,

    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {
    $route: {
        handler: function(val){
            for(let i=0;i<this.tabs.length;i++){
                if(this.tabs[i].path==val.name){
                    this.activeIndex=i
                    return
                }
            }
        },
        immediate:true
    }
  },
  created(){
      this.isApp= localStorage.getItem('isApp') === '0'
  },
  // 组件方法
  methods: {
      ...mapMutations(['updateSave']),
      goTab({path},index){
          if(this.$route.name==path) return;
          this.activeIndex=index
          this.$router.push({
            name:path
          })
      },
      close(){
        this.dialogVisible=false
      },

  },
}
</script>

<style scoped>
.tabs-dialog{
    position: fixed;
    top: 44px;
    left: 0px;
    z-index: 2;
    width: 100%;
    background: #fff;
}
.no-header {
    top: 0 !important;
}
.tabs-container{
    position: relative;
    display: flex;
    align-content: center;
    justify-content: space-between;
    align-content: center;
    padding:  15px;

    background: #fff;
    width: 100%;
     height: 53px;
    margin: 0px auto;
    border-bottom: 1px solid #EBEBEB;
    box-sizing: border-box;
}
.tabs{
    width: 100%;
    display: flex;
    font-size: 16px;
    font-weight: 510;
    color: #0A0E10;
}

.save{
    width: 54px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    border-radius: 3px;
    border-color: #029FD1 ;
    background: #029FD1;
    font-size: 12px;
    color:#fff;

}
.tab{
    font-family: 'PingFang SC Medium';
    position: relative;
}
.active::after{
    position: absolute;
    top: 35px;
    left: 0px;
    content: '';
    width: 63px;
    height: 2px;
    background: #029FD1;
    display: block;
}
.tabs-dialog >>> .dialog-tips{
    width: 120px !important;
}
</style>



// WEBPACK FOOTER //
// src/common/tabs.vue